export default {
  production: {
    apiKey: 'AIzaSyCXApmJDJoWrBniPdBreNhZADQKRQig11c',
    authDomain: 'jand-comic.firebaseapp.com',
    projectId: 'jand-comic',
  },
  development: {
    apiKey: 'AIzaSyD6FJCFg-RLq2tmp-qWo2z-s3ZSUyqMz_c',
    authDomain: 'jand-dev.firebaseapp.com',
    projectId: 'jand-dev',
  },
};
